import { Video } from './../../../models/video';
import { Component, OnInit, Inject, PLATFORM_ID, ChangeDetectorRef } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { DataServiceService } from 'src/app/services/data-service.service';
import { Article } from 'src/app/models/article';
import { SeoService } from 'src/app/services/seo.service';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { SafePipe } from 'src/app/pipes/safe.pipe';
import { LinkedinComponent } from '../../_components/linkedin/linkedin.component';
import { TwitterComponent } from '../../_components/twitter/twitter.component';
import { FacebookComponent } from '../../_components/facebook/facebook.component';
import { SimilarVideosComponent } from '../_components/similar-videos/similar-videos.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Meta } from '@angular/platform-browser';

@Component({
    selector: 'app-video-details',
    templateUrl: './video-details.component.html',
    styleUrls: ['./video-details.component.scss'],
    imports: [
      CommonModule,
      RouterModule,
      SafePipe,
      LinkedinComponent,
      TwitterComponent,
      FacebookComponent,
      SimilarVideosComponent,
      FontAwesomeModule
    ]
})
export class VideoDetailsComponent implements OnInit {

  pageUrl = '';
  tweet = encodeURIComponent(("meta[name='description']")); //.attr("content"));

  // videoHeadline: Article
  // video: Article = new Article()

  videoHeadlines: Video
  video: Video = new Video()
  videos
  faEnvelope = faEnvelope;

  constructor(private route: ActivatedRoute, 
    private dataservice: DataServiceService, 
    private seoservice: SeoService, 
    @Inject(PLATFORM_ID) private platformId: Object,
    private meta: Meta,
    private cdr: ChangeDetectorRef) {
    if (isPlatformBrowser(this.platformId)) {
      this.pageUrl = encodeURIComponent(document.URL);
    }
  }

  shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;
  
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
  
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
  
      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
  
    return array; 
  }

  ngOnInit() {

    this.route.params.subscribe(params => {


      this.dataservice.getVideosDetails(params.friendlyUrl).subscribe(resp => {
        resp[0].imageUrl = resp[0].imageUrl.replace("177x100", "512x288");
        this.video=resp[0];
// $&("this.video2",this.video)

        this.seoservice.updateTitle(this.video.title);
        this.seoservice.updateMetaInfo(
          this.video.description,
          this.video.author,
          this.video.keywords
          );

        this.dataservice.getVideos().subscribe(allVideos => {
         
         // if not current article id 
         var videosWithouthCurrent = allVideos.filter(x=>{ if(x.id !== this.video.id) return x; })

// $&("videosWithouthCurrent",videosWithouthCurrent)
     
        this.videos= this.shuffle(videosWithouthCurrent)

// $&(" this.videos", this.videos)
        this.cdr.detectChanges();
        })

      })

    } );

    this.meta.addTag({ name: 'robots', content: 'nofollow' });
    this.meta.addTag({ name: 'robots', content: 'noindex' });
  }

  socialWindow(url) {
    var left = (screen.width - 570) / 2;
    var top = (screen.height - 570) / 2;
    var params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
    window.open(url, "NewWindow", params);
  }

  emailCurrentPage() {
    window.location.href = "mailto:?subject=" + document.title + "&body=" + escape(window.location.href);
  }

  socialsharefacebook() {
    var url = "https://www.facebook.com/sharer.php?u=" + this.pageUrl;
    this.socialWindow(url);
  };

  socialsharetwitter() {
    var url = "https://twitter.com/intent/tweet?url=" + this.pageUrl + "&text=" + this.tweet;
    this.socialWindow(url);
  };

  socialsharelinkedin() {
    var url = "https://www.linkedin.com/shareArticle?mini=true&url=" + this.pageUrl;
    this.socialWindow(url);
  }

}
